const updateAssetsErrors = (state, { payload: { errors } }) => {
	state.errors = errors;
};

export default updateAssetsErrors;
